module.exports = __webpack_public_path__ + "static/media/1m.1b91e067.svg";